import { t } from 'i18next';
import ServiceNowIcon from '../../../assets/images/service-now-icon.svg';
import { ServiceNowAccordionForm, ServiceNowAccordionFormProps } from './ServiceNowAccordionForm';
import { useState } from 'react';
import { IntegrationAccordion } from '../../../common/components/IntegrationAccordion';

export type ServiceNowAccordionProps = {
  isLoading: boolean;
} & ServiceNowAccordionFormProps;

export const ServiceNowAccordion = (props: ServiceNowAccordionProps) => {
  const { model, isLoading, onConnectClick, onTestClick, canEdit, onUnlinkClick } = props;
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <IntegrationAccordion
      isExpanded={isExpanded}
      onClick={() => setIsExpanded((prev) => !prev)}
      isLoading={isLoading}
      isConfigured={!!model}
      title={t('integrationList.serviceNow.title')}
      subtitle={t('integrationList.serviceNow.description')}
      icon={<ServiceNowIcon width="32" height="32" />}
      details={
        !isLoading && (
          <ServiceNowAccordionForm canEdit={canEdit} model={model} onUnlinkClick={onUnlinkClick} onConnectClick={onConnectClick} onTestClick={onTestClick} />
        )
      }
    />
  );
};
